import { Theme } from "@mui/material";
import { Theme as OnfidoTheme } from "onfido-sdk-ui/types/shared/Types";

export const onfidoStyles: (t: Theme) => OnfidoTheme = theme => ({
  name: "light",
  config: {
    // buttons primary
    colorContentButtonPrimaryText: theme.palette.buttons.primary.default?.color,
    colorBackgroundButtonPrimary:
      theme.palette.buttons.primary.default?.backgroundColor,
    colorBackgroundButtonPrimaryHover:
      theme.palette.buttons.primary.hover?.backgroundColor,
    colorBorderButtonPrimary:
      theme.palette.buttons.primary.default?.borderColor,
    // buttons secondary
    colorContentButtonSecondaryText:
      theme.palette.buttons.secondary.default?.color,
    colorBackgroundButtonSecondary:
      theme.palette.buttons.secondary.default?.backgroundColor,
    colorBorderButtonSecondary:
      theme.palette.buttons.secondary.default?.borderColor,
    colorContentButtonTertiaryText: theme.palette.typography.link,

    // fonts
    fontSizeTitle: "26px",
    fontSizeSubtitle: "16px",
    fontSizeBody: "16px",
    fontWeightTitle: 500,
    fontWeightSubtitle: 500,
    fontWeightBody: 400,
    // others
    borderRadiusButton: theme.palette.buttons.primary.default?.borderRadius,
    borderStyleSurfaceModal: "none",
    colorBackgroundSurfaceModal: theme.palette.common.white,
    colorBackgroundIcon: "rgba(90, 117, 255, 0.2)",
    colorBackgroundButtonIconHover: "transparent",
    colorBackgroundButtonIconActive: "transparent",
    colorBorderDocTypeButton: "transparent",
    colorBorderDocTypeButtonActive: "transparent",
    colorBorderDocTypeButtonHover: "transparent",
  },
});
